import React from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  GridItem,
  Box,
  Grid,
  Button,
  Textarea,
  NumberInput,
  NumberInputField,
} from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';
import { Select as ChakraSelect } from '@chakra-ui/react';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';

const EventForm = ({ events, eventTypes, handleEventChange, removeEvent }) => {
  console.log('Initial Event Type Values:', events.map(event => event.type));

  return (
    <>
      {events.map((event, index) => (
        <GridItem key={index} colSpan={2}>
          <Box p={4} borderWidth={1} borderRadius="md" mb={4}>
            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
              <GridItem>
                <FormControl>
                  <FormLabel>Event Type</FormLabel>
                  <ChakraSelect
                    value={event.type || ''}
                    onChange={(e) => {
                      console.log('Event Type Selected:', e.target.value);
                      handleEventChange(index, 'type', e.target.value);
                    }}
                  >
                    <option value="">Select Event Type</option>
                    {eventTypes.map(type => (
                      <option key={type._id} value={type._id}>
                        {type.name}
                      </option>
                    ))}
                  </ChakraSelect>
                </FormControl>
              </GridItem>

              <GridItem>
                <FormControl>
                  <FormLabel>Guest Count</FormLabel>
                  <NumberInput min={0} value={event.guestCount || 0} onChange={(valueString) => {
                    const value = Number(valueString);
                    console.log('Guest Count Changed:', value);
                    handleEventChange(index, 'guestCount', value);
                  }}>
                    <NumberInputField
                      placeholder="Enter guest count"
                    />
                  </NumberInput>
                </FormControl>
              </GridItem>

              <GridItem colSpan={2}>
                <FormControl>
                  <FormLabel>Event Time</FormLabel>
                  <DateRangePicker
                    startDate={event.startTime ? moment(event.startTime) : null}
                    endDate={event.endTime ? moment(event.endTime) : null}
                    onDatesChange={({ startDate, endDate }) => {
                      console.log('Event Time Changed:', startDate, endDate);
                      handleEventChange(index, 'startTime', startDate ? startDate.toISOString() : null);
                      handleEventChange(index, 'endTime', endDate ? endDate.toISOString() : null);
                    }}
                    focusedInput={event.focusedInput}
                    onFocusChange={focusedInput => handleEventChange(index, 'focusedInput', focusedInput)}
                    displayFormat="YYYY-MM-DD"
                  />
                </FormControl>
              </GridItem>

              <GridItem colSpan={2}>
                <FormControl>
                  <FormLabel>Notes</FormLabel>
                  <Textarea
                    value={event.notes || ''}
                    onChange={(e) => handleEventChange(index, 'notes', e.target.value)}
                    placeholder="Enter event notes"
                  />
                </FormControl>
              </GridItem>
            </Grid>

            {events.length > 1 && (
              <Button
                mt={2}
                size="sm"
                colorScheme="red"
                leftIcon={<DeleteIcon />}
                onClick={() => removeEvent(index)}
              >
                Remove Event
              </Button>
            )}
          </Box>
        </GridItem>
      ))}
    </>
  );
};

export default EventForm;
